import React, { useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import plusCollapseImg from "../../../assets/images/plusCollapse.svg";
import filter from "../../../assets/images/filter.svg";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { usePriorityNew } from "../../../Utils/GetRolePriority";

import "primeicons/primeicons.css";
import _ from "lodash";
import { useSelector } from "react-redux";
import { CustomBreadCrum } from "../../common/CustomBreadcrum";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";

const CDHeader = ({
  setAddNewDesign,
  onSelectAll,
  label,
  headerName,
  disabled,
  data,
  selectAllCheckbox,
  showFilterHeaders,
  pageEdited,
  setPageEdited,
  lastLabel,
  checkReadWriteAccess,
}) => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const location = useLocation();
  let { page1, page2, pageType, TaskID, ProjectID } = useParams();
  const locationPath = location?.pathname;
  const url = locationPath?.split("/");
  const mytasks = url[1];
  // const checkReadWriteAccess = usePriorityNew(mytasks);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User.userInformation;
  // const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();

  const handleCrossIconClick = () => {
    if (pageEdited) {
      setShowDialog(true);
    } else {
      handleCrossIcon();
    }
  };

  const handleCrossIcon = () => {
    if (page2 && page2 === "projectPlan") {
      navigate(`/${page1}/${page2}/${ProjectID}`);
    } else if (pageType) {
      navigate(`/${pageType}`);
    }
  };

  const confirmNavigation = () => {
    markClean();
    handleCrossIcon();
    setPageEdited(false);
    setShowDialog(false);
  };

  const cancelNavigation = () => {
    setShowDialog(false);
  };

  const isTaskCompleteOrCancelled = (taskStatus) => {
    return taskStatus === "Complete" || taskStatus === "Cancelled";
  };


  // useEffect(()=>{
  //   if(User && data){
  //   if(userInformation?.userid === data?.Assignee){
  //     setCheckReadWriteAccess(true);
  //   }else{
  //     setCheckReadWriteAccess(false);
  //   }
  // }
  // },[User,data])

  return (
    <div className="content-layout task-layout">
      <i
        className="pi pi-times"
        // onClick={() => {
        //   if (page2 && page2 === "projectPlan") {
        //     navigate(`/${page1}/${page2}/${ProjectID}`);
        //   } else if (pageType) {
        //     navigate(`/${pageType}`);
        //   }
        // }}
        onClick={handleCrossIconClick}
      ></i>
      <div className="actions">
        <div>
          {/* <BreadCrumb model={breadcrumb} /> */}
          <nav className="p-breadcrumb p-component" aria-label="Breadcrumb">
            <ul>
              <li className="p-breadcrumb-chevron pi pi-chevron-right"></li>

              {url[2] === "projectPlan" ? (
                <>
                  <CustomBreadCrum
                    items={[
                      { label: _.startCase(mytasks), url: `/${mytasks}` },
                      { label: _.startCase(url[2]), url: `/${mytasks}/${url[2]}/${url[5]}` },
                    ]}
                    lastLabel={lastLabel}
                    iconColorBlack={true}
                    lastChildSecondChild={true}
                  />

                  {/* <li className="">
                    <NavLink to={`/${mytasks}`} className="p-menuitem-link">
                      <span className="p-menuitem-text">
                        {_.startCase(mytasks)}
                      </span>
                    </NavLink>{" "}
                  </li>{" "} */}
                  {/* <li className="p-breadcrumb-chevron pi pi-chevron-right"></li> */}
                  {/* <li className="">
                    <NavLink
                      to={`/${mytasks}/${url[2]}/${url[5]}`}
                      className="p-menuitem-link"
                    >
                      <span className="p-menuitem-text">
                        {_.startCase(url[2])}
                      </span>
                    </NavLink>{" "}
                  </li> */}
                </>
              ) : (
                <>
                  <CustomBreadCrum
                    items={[{ label: _.startCase(mytasks), url: `/${mytasks}` }]}
                    lastLabel={lastLabel}
                    iconColorBlack={true}
                    lastChildSecondChild={false}
                  />
                  {/* <li className="">
                    <NavLink to={`/${mytasks}`} className="p-menuitem-link">
                      <span className="p-menuitem-text">
                        {_.startCase(mytasks)}
                      </span>
                    </NavLink>{" "}
                  </li> */}
                </>
              )}

              <li className="p-breadcrumb-chevron pi pi-chevron-right"></li>
              {/* <li className="">
                <a href="#" className="p-menuitem-link">
                  <span className="p-menuitem-text">{label}</span>
                </a>
              </li> */}
              <CustomBreadCrum 
                items={[{ label: label, url: `` }]} 
                lastChildSecondChild={false}
                iconColorBlack={true}
                lastLabel={lastLabel} 
                customStyle={{color:"#003da5", fontWeight:500}}
              />
            </ul>
          </nav>
          <div className="project-title">{headerName}</div>
        </div>

       {!showFilterHeaders && <div className="action-buttons">
          <div className="icon-items">
            <Checkbox
              onChange={(e) => {
                setChecked(e.checked);
                onSelectAll(e.checked);
              }}
              checked={selectAllCheckbox}
              className="margin-right"
              disabled={
                !checkReadWriteAccess ||
                disabled ||
                isTaskCompleteOrCancelled(data?.Task_Status)
              }
            ></Checkbox>
            <div className="icon-label">
              <label
                className={
                  (!checkReadWriteAccess ||
                    disabled ||
                    isTaskCompleteOrCancelled(data?.Task_Status)) &&
                  "disable-buttons"
                }
              >
                {" "}
                Select All{" "}
              </label>
            </div>
          </div>
          <div className="icon-items">
            <img
              src={filter}
              alt="filter logo"
              className="filter-icon filter-color-change"
              disabled={
                !checkReadWriteAccess ||
                disabled ||
                isTaskCompleteOrCancelled(data?.Task_Status)
              }
            />
            <div>
              <label
                className="icon-label"
                disabled={
                  !checkReadWriteAccess ||
                  disabled ||
                  (isTaskCompleteOrCancelled(data?.Task_Status) && true)
                }
              >
                filter
              </label>
            </div>
          </div>
          <div className="icon-items" style={{ textAlign: "center" }}>
            <img
              src={plusCollapseImg}
              onClick={() => setAddNewDesign && setAddNewDesign()}
              className={`add-new-design-intent-icon ${
                (!checkReadWriteAccess ||
                  disabled ||
                  isTaskCompleteOrCancelled(data?.Task_Status)) &&
                "disabled-add"
              }`}
              alt=""
              disabled={(!setAddNewDesign && true) || isTaskCompleteOrCancelled(data?.Task_Status)}
            />
            <div className="icon-label">
              <label
                className={
                  (!checkReadWriteAccess ||
                    disabled ||
                    isTaskCompleteOrCancelled(data?.Task_Status)) &&
                  "disable-buttons"
                }
              >
                Add Color Development
              </label>
            </div>
          </div>
        </div> }
      </div>
      {/* UnsavedChangesDialog popup*/}
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
    </div>
  );
};

export default CDHeader;
